<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo-section" @click="$router.push('/')" style="cursor: pointer;">
          <div class="logo">
            <img :src="companyConfig.logoUrl ? $http.getFullImageUrl(companyConfig.logoUrl) : require('@/assets/img/toplogo.png')" :alt="companyConfig.name" />
          </div>
          <span class="company-name">{{ companyConfig.name || '内蒙古财达企业管理咨询有限公司' }}</span>
        </div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-demo"
          mode="horizontal"
          :router="true"
        >
          <!-- 动态菜单项 -->
          <template v-if="menuItems.length > 0">
            <el-menu-item 
              v-for="item in menuItems" 
              :key="item.id"
              :index="item.url"
            >
              {{ item.name }}
            </el-menu-item>
          </template>
          <!-- 默认菜单项（如果没有配置） -->
          <template v-else>
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/enterprises">企业信息</el-menu-item>
            <el-menu-item index="/tax-agency">税务代办</el-menu-item>
            <el-menu-item index="/services">交易信息</el-menu-item>
          </template>
          <!-- 管理后台和用户菜单 -->
          <el-menu-item index="/admin" v-if="isAdmin">管理后台</el-menu-item>
          <el-menu-item index="/login" v-if="!isLoggedIn">登录</el-menu-item>
          <el-submenu index="user" v-if="isLoggedIn">
            <template slot="title">{{ username }}</template>
            <el-menu-item @click="logout">退出登录</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <!-- 动态底部链接 -->
            <template v-if="footerGroups.length > 0">
              <li v-for="group in footerGroups" :key="group.id">
                <p>{{ group.title }}</p>
                <!-- 如果是"联系我们"或"联系方式"分组，使用公司配置信息 -->
                <template v-if="group.title === '联系我们' || group.title === '联系方式'">
                  <a :href="'tel:' + (companyConfig.phone || '15024746474')" class="contact-link">
                    <i class="el-icon-phone"></i>
                    电话：{{ companyConfig.phone || '15024746474' }}
                  </a>
                  <a :href="'mailto:' + (companyConfig.email || '306363083@qq.com')" class="contact-link">
                    <i class="el-icon-message"></i>
                    邮箱：{{ companyConfig.email || '306363083@qq.com' }}
                  </a>
                  <a :href="'https://map.baidu.com/?newmap=1&ie=utf-8&s=s%26wd%3D' + encodeURIComponent(companyConfig.address || '内蒙古自治区包头市稀土开发区软件园大厦B105-152')" target="_blank" class="contact-link">
                    <i class="el-icon-location"></i>
                    地址：{{ companyConfig.address || '内蒙古自治区包头市包头稀土高新技术产业开发区软件园大厦C406-7-8-9' }}
                  </a>
                </template>
                <!-- 其他分组使用配置的链接 -->
                <template v-else-if="footerLinks[group.id]">
                  <a 
                    v-for="link in footerLinks[group.id]" 
                    :key="link.id"
                    :href="link.url || 'javascript:void(0)'"
                    class="contact-link"
                    @click="!link.url && $event.preventDefault()"
                  >
                    <i v-if="link.icon" :class="link.icon"></i>
                    {{ link.text }}
                  </a>
                </template>
              </li>
            </template>
            <!-- 默认底部链接（如果没有配置） -->
            <template v-else>
              <li>
                <p>服务项目</p>
                <a href="/enterprises" class="contact-link" @click.prevent="navigateTo('/enterprises')">企业信息</a>
                <a href="/tax-agency" class="contact-link" @click.prevent="navigateTo('/tax-agency')">工商税务</a>
                <a href="/services" class="contact-link" @click.prevent="navigateTo('/services')">交易信息</a>
              </li>
              <li>
                <p>关于我们</p>
                <a href="/" class="contact-link" @click.prevent="navigateTo('/')">公司简介</a>
                <a href="/" class="contact-link" @click.prevent="navigateTo('/')">企业文化</a>
              </li>
              <li>
                <p>联系我们</p>
                <a :href="'tel:' + (companyConfig.phone || '15024746474')" class="contact-link">
                  <i class="el-icon-phone"></i>
                  电话：{{ companyConfig.phone || '15024746474' }}
                </a>
                <a :href="'mailto:' + (companyConfig.email || '306363083@qq.com')" class="contact-link">
                  <i class="el-icon-message"></i>
                  邮箱：{{ companyConfig.email || '306363083@qq.com' }}
                </a>
                <a :href="'https://map.baidu.com/?newmap=1&ie=utf-8&s=s%26wd%3D' + encodeURIComponent(companyConfig.address || '内蒙古自治区包头市稀土开发区软件园大厦B105-152')" target="_blank" class="contact-link">
                  <i class="el-icon-location"></i>
                  地址：{{ companyConfig.address || '内蒙古自治区包头市包头稀土高新技术产业开发区软件园大厦C406-7-8-9' }}
                </a>
              </li>
            </template>
          </ul>
        </div>
        <div class="copyright">
          <span>© 2026 {{ companyConfig.name || '内蒙古财达企业管理咨询有限公司' }} 版权所有</span>
          <span><a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15029002000537" target="_blank">蒙公网安备15029002000537号</a></span>
          <span><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蒙ICP备2026000617号</a></span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      isLoggedIn: false,
      isAdmin: false,
      companyConfig: {},
      menuItems: [],
      footerGroups: [],
      footerLinks: {}
    };
  },
  mounted() {
    this.checkLoginStatus();
    this.loadConfigs();
  },
  watch: {
    '$route'() {
      this.checkLoginStatus();
    }
  },
  methods: {
    async loadConfigs() {
      try {
        // 加载公司配置
        const companyRes = await this.$http.get('/config/company');
        if (companyRes.success && companyRes.data) {
          this.companyConfig = companyRes.data;
        }

        // 加载菜单配置
        const menuRes = await this.$http.get('/config/menu');
        if (menuRes.success && menuRes.data) {
          this.menuItems = menuRes.data;
        }

        // 加载底部链接配置
        const footerRes = await this.$http.get('/config/footer');
        if (footerRes.success && footerRes.data) {
          this.footerGroups = footerRes.data.groups || [];
          this.footerLinks = footerRes.data.links || {};
        }
      } catch (error) {
        console.error('加载配置失败:', error);
        // 使用默认配置，不显示错误消息
      }
    },
    checkLoginStatus() {
      const token = localStorage.getItem('token');
      const username = localStorage.getItem('username');
      const role = localStorage.getItem('userRole');
      
      this.isLoggedIn = !!token;
      this.username = username || '';
      this.isAdmin = role === 'ADMIN';
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('userRole');
      this.isLoggedIn = false;
      this.isAdmin = false;
      this.$router.push('/');
      this.$message.success('已退出登录');
    },
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;

  .logo-section {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    
    .logo {
      width: 50px;
      height: 50px;
      flex-shrink: 0;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }
    
    .company-name {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      white-space: nowrap;
    }
  }
}

.el-main {
  padding: 0 !important;
  flex: 1;
}

.footer {
  width: 100%;
  background: #0f172a; /* 高端黑曜石深蓝灰 */
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;

  /* 顶部的极细高质感渐变微光线条 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 600px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.3), transparent);
  }
  
  &-content {
    max-width: 1240px;
    width: 100%;
    margin: 0 auto;
    padding: 60px 20px 40px 20px;
    box-sizing: border-box;

    .content-nav {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      padding: 0;
      list-style: none;

      li {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex: 1;
        min-width: 240px;
        margin-bottom: 20px;

        p {
          font-size: 16px;
          color: #ffffff;
          font-weight: 600;
          margin: 0 0 20px 0;
          padding-bottom: 12px;
          position: relative;
          width: 100%;
          border-bottom: none;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 36px;
            height: 2px;
            background: #3b82f6; /* 精致蓝色饰条 */
            border-radius: 2px;
          }
        }

        a.contact-link {
          color: rgba(255, 255, 255, 0.65);
          font-weight: 400;
          padding: 8px 0;
          font-size: 14px;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          line-height: 1.6;
          
          &:hover {
            color: #3b82f6;
            text-decoration: none;
            transform: translateX(6px);
            
            i {
              color: #3b82f6;
              transform: scale(1.1);
            }
          }
          
          i {
            margin-right: 10px;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.4);
            transition: all 0.25s ease;
          }
        }
      }
    }
  }

  .copyright {
    min-height: 60px;
    padding: 20px;
    background: #0b0f19; /* 更加深邃的底部版权区 */
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
    box-sizing: border-box;

    span {
      color: rgba(255, 255, 255, 0.45);
      font-size: 13px;
      font-weight: 400;
      display: inline-flex;
      align-items: center;

      a {
        color: rgba(255, 255, 255, 0.45);
        text-decoration: none;
        transition: color 0.25s ease;

        &:hover {
          color: #3b82f6;
          text-decoration: none;
        }
      }
    }

    @media screen and (min-width: 769px) {
      span:not(:last-child)::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: 12px;
        background: rgba(255, 255, 255, 0.15);
        margin-left: 24px;
        vertical-align: middle;
      }
    }
  }
}

// 响应式设计
@media screen and (max-width: 768px) {
  .el-header {
    flex-direction: column;
    height: auto !important;
    padding: 10px 15px;
    
    .logo-section {
      margin-bottom: 10px;
      
      .logo {
        width: 40px;
        height: 40px;
      }
      
      .company-name {
        font-size: 14px;
        white-space: normal;
        text-align: center;
      }
    }
    
    .el-menu-demo {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      border-bottom: none;
      
      .el-menu-item {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
        font-size: 14px;
      }
      
      .el-submenu {
        .el-submenu__title {
          height: 36px;
          line-height: 36px;
          padding: 0 12px;
          font-size: 14px;
        }
      }
    }
  }

  .footer {
    &-content {
      width: 100%;
      padding: 40px 20px 20px 20px;
      
      .content-nav {
        flex-direction: column;
        gap: 30px;
        padding: 0;
        
        li {
          min-width: auto;
          margin-bottom: 0;
          
          p {
            font-size: 16px;
            padding-bottom: 8px;
            margin-bottom: 12px;
          }
          
          a.contact-link {
            font-size: 14px;
            padding: 6px 0;
          }
        }
      }
    }
    
    .copyright {
      padding: 15px 20px;
      flex-direction: column;
      gap: 8px;
      height: auto;
      
      span {
        font-size: 12px;
        line-height: 1.4;
      }
    }
  }
}

</style>
